import { render, staticRenderFns } from "./WeekSelectedDays.vue?vue&type=template&id=6b851409&scoped=true&"
import script from "./WeekSelectedDays.vue?vue&type=script&lang=js&"
export * from "./WeekSelectedDays.vue?vue&type=script&lang=js&"
import style0 from "./WeekSelectedDays.vue?vue&type=style&index=0&id=6b851409&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b851409",
  null
  
)

export default component.exports